import Pixabay from './Pixabay'

const PIXABAY = 'pixabay'

class ImageProvider {
  get list () {
    return [
      PIXABAY
    ]
  }

  search (provider, key, options = {}) {
    switch (provider) {
      case PIXABAY:
        return Pixabay(key, options)
      default:
        throw new Error('Invalid provider: ' + provider)
    }
  }
}

export default new ImageProvider()
